import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

import { FaArrowLeft, FaEnvelope, FaCalendarAlt, FaSpinner, FaExclamationTriangle } from "react-icons/fa";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import MatchPairOverallScore from "./MatchPairOverallScore";

import Tabs from "./Tabs"; // Adjust the path as necessary
import Modal from "../../../components/Modal/Modal";
import MessageModal from "./MessageModal";
import MeetingModal from "./MeetingModal";

const DeepAnalyzeComponent = () => {
  let navigate = useNavigate();
  const { state } = useLocation();
  const currentRecord = state;
  const [clinicalRecords, setClinicalRecords] = useState();
  const [currentActiveTab, setCurrentActiveTab] = useState();
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [showMeetingModal, setShowMeetingModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const [qualifiedPairs, setQualifiedPairs] = useState({
    primary_recipient_id: currentRecord?.primaryRecipient?._id,
    primary_donor_id: currentRecord?.primaryDonor?._id,
    secondary_recipient_id: currentRecord?.secondaryRecipient?._id,
    secondary_donor_id: currentRecord?.secondaryDonor?._id,
  });

  const toggleMessageModal = () => {
    setShowMessageModal(!showMessageModal);
  };

  const toggleMeetingModal = () => {
    setShowMeetingModal(!showMeetingModal);
  };

  const getClinicalRecords = () => {
    setIsLoading(true);
    setError(null);

    let userToken = localStorage.getItem("token");
    let urlLink = `${process.env.REACT_APP_API_URL}/clinical/pair`;
    const config = {
      method: "post",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: qualifiedPairs,
    };

    axios(config)
      .then(function (response) {
        console.log(response.data);
        setClinicalRecords(response.data);
        setIsLoading(false);
      })
      .catch(function (err) {
        console.log("error api call ", err?.response?.data);
        setError(err?.response?.data?.message || "Failed to load clinical records");
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getClinicalRecords();
  }, []);

  return (
    <MainTemplate>
      <CardBackground>
        {showMessageModal && (
          <Modal onClose={toggleMessageModal}>
            {/* <ViewModal currentRecord={currentRecord} /> */}
            <MessageModal currentRecord={currentRecord} />
          </Modal>
        )}
        {showMeetingModal && (
          <Modal onClose={toggleMeetingModal}>
            {/* <ViewModal currentRecord={currentRecord} /> */}
            <MeetingModal currentRecord={currentRecord} onClose={toggleMeetingModal} />
          </Modal>
        )}
        <div className="w-full">
          <div className="p-4 mb-6 bg-gray-100 rounded-lg shadow-sm">
            <div className="flex items-center justify-between">
              <h1 className="text-2xl font-bold text-gray-800">
                Deep Analyze v1.0
              </h1>
              <div className="flex space-x-4">
                <button
                  onClick={() => navigate(-1)}
                  className="flex items-center px-4 py-2 text-white transition duration-300 bg-gray-500 rounded-md hover:bg-gray-600"
                >
                  <FaArrowLeft className="mr-2" />
                  Back
                </button>
                <button
                  onClick={() => toggleMessageModal(currentRecord)}
                  className="flex items-center px-4 py-2 text-white transition duration-300 bg-blue-500 rounded-md hover:bg-blue-600"
                >
                  <FaEnvelope className="mr-2" />
                  Message Consultant
                </button>
                <button
                  onClick={() => toggleMeetingModal(currentRecord)}
                  className="flex items-center px-4 py-2 text-white transition duration-300 bg-green-500 rounded-md hover:bg-green-600"
                >
                  <FaCalendarAlt className="mr-2" />
                  Schedule Meeting
                </button>
              </div>
            </div>
          </div>

          {isLoading ? (
            <div className="flex flex-col items-center justify-center p-12 bg-white rounded-lg shadow">
              <FaSpinner className="w-10 h-10 mb-4 text-indigo-500 animate-spin" />
              <p className="text-lg font-medium text-gray-600">
                Loading clinical records...
              </p>
            </div>
          ) : error ? (
            <div className="p-6 bg-red-50 border border-red-200 rounded-lg">
              <div className="flex items-center mb-2">
                <FaExclamationTriangle className="mr-2 text-red-600" />
                <h3 className="text-lg font-semibold text-red-700">
                  Error Loading Data
                </h3>
              </div>
              <p className="text-red-600">{error}</p>
              <button
                onClick={getClinicalRecords}
                className="px-4 py-2 mt-4 text-white bg-red-500 rounded hover:bg-red-600"
              >
                Retry
              </button>
            </div>
          ) : (
            <>
              <MatchPairOverallScore pair={currentRecord} />

              <div className="mt-6">
                <Tabs
                  currentRecord={currentRecord}
                  clinicalRecords={clinicalRecords}
                  qualifiedPairs={qualifiedPairs}
                  setCurrentActiveTab={setCurrentActiveTab}
                />
              </div>
            </>
          )}
        </div>
      </CardBackground>
    </MainTemplate>
  );
};

export default DeepAnalyzeComponent;
